import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import "./Button.scss";

function getStyle(icon) {
  if (icon) {
    return {
      backgroundImage: `url(${icon})`
    };
  }

  return {};
}

const Button = ({ children, color, disabled, onClick, icon, className }) => (
  <button
    className={classnames("button", className, color, { disabled, icon: icon })}
    type="button"
    onClick={() => !disabled && onClick && onClick()}
    style={getStyle(icon)}
  >
    {children}
  </button>
);

Button.propTypes = {
  color: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  icon: PropTypes.string
};

Button.defaultProps = {
  color: "blue",
  disabled: false
};

export default Button;
